import React, { useState } from "react";
import { css } from "emotion";
import { bindActionCreators } from "redux";
import { connect, useSelector } from "react-redux";
import { notification } from "antd";
import req from "../../utilities/request-utility";

import { hideDialog, hideModalPage, showDialog } from "../../actions/uiActions";

// Icons
import { LockQuestionIcon, AlertDecagramIcon } from "mdi-react";

// Components
import TextInput from "../ui/TextInput";
import Button from "../ui/Button";
import ScrollView from "../ui/ScrollView";
import colors from "../../style/colors";

const ForgotPassword = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [loginData, setLoginData] = useState(props.prefillValue || "");
  const appConfig = useSelector((state) => state.appConfig);

  const renewPassword = async () => {
    setIsLoading(true);

    const isPhone = loginData.startsWith("+");

    if (isPhone && !loginData.match(/^[+][0-9]{10,15}$/)) {
      notification.error({ duration: 7, message: "FAILED", description: "Invalid phone number format" });
      setIsLoading(false);
      return;
    }

    if (!isPhone && !loginData.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)) {
      notification.error({ duration: 7, message: "FAILED", description: "Invalid email format" });
      setIsLoading(false);
      return;
    }

    try {
      await req().post("auth/renew-password", { loginData, applicationId: appConfig.appId });
      notification.success({
        duration: 7,
        message: "SUCCESS",
        description: `A new password has been sent to your ${isPhone ? "phone number" : "email"}.`,
      });
    } catch (error) {
      notification.error({ duration: 7, message: "FAILED", description: "Could not reset your password" });
    }

    setIsLoading(false);
  };

  const handlePasswordReset = () => {
    let dialog = {
      title: "Warning",
      content:
        "You are about to request a new password. Doing so will deactivate your old password and you will no longer be able to access the app with it",
      icon: <AlertDecagramIcon />,
      styleType: "warning",
      primaryActionTitle: "Okay, request a new password",
      secondaryActionTitle: "Cancel, keep my old password",
      primaryAction: renewPassword,
    };
    props.showDialog(dialog);
  };

  return (
    <>
      <ScrollView className={componentStyle(props)} style={{ backgroundColor: "#ffffff" }}>
        <div className="forgot-password-container">
          <div className="icon-container">
            <LockQuestionIcon className="lock-icon" size={50} color={appConfig.primaryColor} />
          </div>
          <h3 style={{ marginBottom: "1rem" }}>Forgot your password?</h3>
          <p style={{ marginBottom: "3rem" }}>
            Use the form below to reset your password. You will receive a new one to your phone
          </p>
          <TextInput
            style={{ marginBottom: "1rem" }}
            onChange={(e) => setLoginData(e.target.value)}
            placeholder={`Enter your email or phone number`}
            value={loginData}
          />
          <Button
            disabled={loginData === "" || isLoading}
            onClick={handlePasswordReset}
            title={isLoading ? "Renewing..." : "Request a new password"}
          />
        </div>
      </ScrollView>
    </>
  );
};

const componentStyle = (props) => css`
  .forgot-password-container {
    padding: 0.7rem;
    width: 100%;
    height: 100%;
    max-width: 500px;
    margin: 0 auto;
    color: ${colors.black};
    text-align: center;

    .icon-container {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 78px;
      height: 78px;
      border: 1px ${colors.lightGrey} solid;
      border-radius: 50%;
      margin: 2rem auto;

      svg {
        width: 32px;
        height: 32px;
      }
    }
  }
`;

const mapDispatchToProps = (dispatch) => ({
  showDialog: bindActionCreators(showDialog, dispatch),
  hideDialog: bindActionCreators(hideDialog, dispatch),
  hideModalPage: bindActionCreators(hideModalPage, dispatch),
});

export default connect(null, mapDispatchToProps)(ForgotPassword);
